import script from "./JpPdf.vue?vue&type=script&setup=true&lang=ts"
export * from "./JpPdf.vue?vue&type=script&setup=true&lang=ts"

import "./JpPdf.vue?vue&type=style&index=0&id=1ca62aa0&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca62aa0"]])

export default __exports__